module.exports = __webpack_public_path__ + "static/img/subject_bg2.d571aea6.png";